import { useState } from "react";
import DashboardTopBar from "./DashboardTopBar";
import DashboardSidebar from "./DashboardSidebar";
import { useUserState } from './UserStateProvider';

const ContentWrapper = ({ children, className }) => {
    const { theme,} = useUserState();
    const [isSidebarActive, setIsSidebarActive] = useState(false); // State to manage sidebar class

    const toggleSidebar = () => {
        setIsSidebarActive(prevState => !prevState); // Toggle the sidebar class
    };

    return (
        <div id="page" className={`${theme === 'light' ? 'light-mode' : ''}`}>
            <DashboardTopBar/>
            <div id="content-wrapper" className={ className }>
                <DashboardSidebar isActive={isSidebarActive} toggleSidebar={toggleSidebar}/>
                <div id="main-content" className="tif-bg-color-tertiary tif-bg-light-color-white tif-color-white tif-light-color-november flex-grow-1">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ContentWrapper;